import { render, staticRenderFns } from "./DisableAccount.vue?vue&type=template&id=2c3f42d0&scoped=true&"
import script from "./DisableAccount.vue?vue&type=script&lang=js&"
export * from "./DisableAccount.vue?vue&type=script&lang=js&"
import style0 from "./DisableAccount.vue?vue&type=style&index=0&id=2c3f42d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f42d0",
  null
  
)

export default component.exports